<template>
  <div class="ts-overflow-y-scroll" style="max-height: 40vh; min-height: 25vh">
    <table class="ts-w-full">
      <thead>
        <tr>
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
          >
            {{ $t('luckyDrawAvailableItem.itemNameEn') }}
          </th>
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
          >
            {{ $t('luckyDrawAvailableItem.quantity') }}
          </th>
          <th class="ts-border ts-text-center ts-w-1" v-if="!is_update">
            <a href="#" class="ts-text-white" @click.prevent="addNewRow">
              <i class="fa fa-plus"></i>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(detail, index) in model.item_list" :key="index">
          <td valign="top" class="ts-w-3/5">
            <input
              type="text"
              class="form-control"
              readonly
              :value="detail.item_name_en"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('item_list.' + index + '.item_id')"
            >
              {{ errors.first('item_list.' + index + '.item_id') }}
            </div>
          </td>
          <td valign="top" class="ts-w-2/5">
            <input
              v-model.number="detail.quantity"
              type="number"
              class="form-control"
              :readonly="is_update"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('item_list.' + index + '.item_id')"
            >
              {{ errors.first('item_list.' + index + '.item_id') }}
            </div>
          </td>
          <td class="ts-text-center" valign="middle" v-if="!is_update">
            <a
              href="#"
              class="ts-text-red-600 ts-my-auto"
              @click.prevent="removeRow(detail)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- modal show pop-up to be able add product -->
    <a-modal
      v-if="show_modal_add_item"
      v-model="show_modal_add_item"
      :footer="null"
      :zIndex="1020"
      :maskClosable="false"
      width="450px"
      :title="$t('luckyDrawAvailableItem.luckyDrawItem')"
    >
      <LuckyDrawItem v-model="model" />
    </a-modal>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import LuckyDrawItem from './lucky-draw-item.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'itemLists',
  props: ['value', 'validate', 'is_update'],
  components: {
    LuckyDrawItem
  },
  data () {
    return {
      errors: new Errors(),
      show_modal_add_item: false,
      model: {},
      newRow: {
        item_id: null,
        item_name_en: null,
        item_name_kh: null,
        quantity: null
      }
    }
  },
  created () {
    this.model = this.value
  },
  computed: {
    ...mapGetters('luckyDraw/luckyDrawAvailableItem', ['findItem', 'getItem'])
  },
  methods: {
    addNewRow () {
      this.show_modal_add_item = true
    },
    removeRow (row) {
      this.model.item_list.splice(this.model.item_list.indexOf(row), 1)
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
table thead tr th {
  padding: 4px 5px;
  z-index: 3;
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  background-color: rgb(22, 102, 145);
  color: white;
}

table tbody tr td {
  padding: 4px 5px;
}
table {
  position: relative;
  border-collapse: collapse;
}
</style>
